
const ACDepartmentLayout = {
    valueExpr: 'id',
    displayExpr: 'department',
    sort: [{ selector: "department", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5851afc2-3b14-4526-97c4-c0783010ed96',
    selectboxlabel: 'Department',
    params: {
        module: "ac",
        lookupType: "ACDepartments",
        showLookupGrid: true
    },
    columns: [
        { dataField: "department", caption: "Department", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
        { dataField: "companyid", caption: "CompanyId", dataType: "string", visible: false },
        { dataField: "module", caption: "Module", dataType: "string", visible: false },
        { dataField: "recordtype", caption: "Record Type", dataType: "string", visible: false },
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible: false },
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible: false },
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible: false },
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible: false },
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible: false },
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible: false },
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible: false },
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible: false },
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible: false },
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible: false },
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible: false },
        { dataField: "userdefineddate1", caption: "Date 1", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate6", caption: "Date 6", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate7", caption: "Date 7", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate8", caption: "Date 8", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate9", caption: "Date 9", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefineddate10", caption: "Date 10", dataType: "datetime", format: "MM/dd/yyyy", visible: false },
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", format: { type: 'fixedPoint', precision: 2, useGrouping: true }, visible: false },
        { dataField: "popupmessag", caption: "POPUPMEASAGE", dataType: "string", visible: false },
    ]
};
const ACReceiptMethodSetup = {
    valueExpr: 'id',
    displayExpr: 'receiptmethod',
    sort: [{ selector: "receiptmethod", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '5851afc2-3b14-4526-97c4-c0783010ed96',
    params: {
        module: "ac",
        lookupType: "AcReceiptMethodSetups",
        showLookupGrid: true
    },
    columns: [
        { dataField: "receiptmethod", caption: "Receipt Method", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Updated", dataType: "datetime", format: "MM/dd/yyyy hh:mm:ss a", visible: false },
        { dataField: "lastupdateuserid", caption: "Last Updated By", dataType: "string", visible: false },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
        { dataField: "companyid", caption: "CompanyId", dataType: "string", visible: false },
        { dataField: "module", caption: "Module", dataType: "string", visible: false },
        { dataField: "recordtype", caption: "Record Type", dataType: "string", visible: false },
        { dataField: "popupmessag", caption: "POPUPMEASAGE", dataType: "string", visible: false },
    ]
};
const AccountLookup = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'EC20D573-9150-43C8-AB2F-582C38FF23BF',
    params: {
        module: "ac",
        lookupType: "ACAccount",
        showLookupGrid: true,
        accountType:'D',
    },
    columns: [
        { dataField: "name", caption: "Account", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        {visible:false, dataField: "description2", caption: "Description 2", dataType: "string" },
        {visible:false, dataField: "status", caption: "Status", dataType: "string" },
        {visible:false, dataField: "category", caption: "Category", dataType: "string" },
        {visible:false, dataField: "uom", caption: "UOM", dataType: "string" },
        {visible:false, dataField: "type", caption: "Type", dataType: "string" },
        {visible:false, dataField: "headinglevel", caption: "Heading Level", dataType: "string" },
        {visible:false, dataField: "keysequence", caption: "Key Sequence", dataType: "string" },
        {visible:false, dataField: "reconciliationtype", caption: "Reconciliation Type", dataType: "string" },
        {visible:false, dataField: "cash", caption: "Cash", dataType: "string" },
        {visible:false, dataField: "asset", caption: "Asset", dataType: "string" },
        {visible:false, dataField: "investment", caption: "Investment", dataType: "string" },
        {visible:false, dataField: "payrolldeduction", caption: "Payroll Deduction", dataType: "string" },
        {visible:false, dataField: "settlementdeduction", caption: "Settlement Deduction", dataType: "string" },
        {visible:false, dataField: "efexpense", caption: "EF Expense", dataType: "string" },
        {visible:false, dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string" },
        {visible:false, dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string" },
        {visible:false, dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string" },
        {visible:false, dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string" },
        {visible:false, dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string" },
        {visible:false, dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string" },
        {visible:false, dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string" },
        {visible:false, dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string" },
        {visible:false, dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string" },
        {visible:false, dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string" },
        {visible:false, dataField: "userdefineddate1", caption: "Date 1", dataType: "date" },
        {visible:false, dataField: "userdefineddate2", caption: "Date 2", dataType: "date" },
        {visible:false, dataField: "userdefineddate3", caption: "Date 3", dataType: "date" },
        {visible:false, dataField: "userdefineddate4", caption: "Date 4", dataType: "date" },
        {visible:false, dataField: "userdefineddate5", caption: "Date 5", dataType: "date" },
        {visible:false, dataField: "userdefineddate6", caption: "Date 6", dataType: "date" },
        {visible:false, dataField: "userdefineddate7", caption: "Date 7", dataType: "date" },
        {visible:false, dataField: "userdefineddate8", caption: "Date 8", dataType: "date" },
        {visible:false, dataField: "userdefineddate9", caption: "Date 9", dataType: "date" },
        {visible:false, dataField: "userdefineddate10", caption: "Date 10",dataType:"date" },
        {visible:false, dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "string" },
        {visible:false, dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "string" },
        {visible:false, dataField: "altcurrencytiming", caption: "Alt Currency Timing", dataType: "string" },
        {visible:false, dataField: "rfxcurrency", caption: "RFX Currency", dataType: "string" },
        {visible:false, dataField: "accountnum", caption: "Account Num", dataType: "string" },
        {visible:false, dataField: "popupmessage", caption: "Popup Message", dataType: "string" },
        {visible:false, dataField: "creationdatetime", caption: "Creation Date Time", dataType: "datetime" },
        {visible:false, dataField: "creationuserid", caption: "Creation User ID", dataType: "string" },
        {visible:false, dataField: "lastupdatedatetime", caption: "Last Update Date Time", dataType: "datetime" },
        {visible:false, dataField: "lastupdateuserid", caption: "Last Update User ID", dataType: "string" },
        {visible:false, dataField: "companyid", caption: "Company ID", dataType: "string" },
        {visible:false, dataField: "module", caption: "Module", dataType: "string" },
        {visible:false, dataField: "recordtype", caption: "Record Type", dataType: "string" },
        {visible:false, dataField: "userdefinedcode1", caption: "Code 1", dataType: "string" },
        {visible:false, dataField: "userdefinedcode2", caption: "Code 2", dataType: "string" },
        {visible:false, dataField: "userdefinedcode3", caption: "Code 3", dataType: "string" },
        {visible:false, dataField: "userdefinedcode4", caption: "Code 4", dataType: "string" },
        {visible:false, dataField: "userdefinedcode5", caption: "Code 5", dataType: "string" },
        {visible:false, dataField: "userdefinedcode6", caption: "Code 6", dataType: "string" },
        {visible:false, dataField: "userdefinedcode7", caption: "Code 7", dataType: "string" },
        {visible:false, dataField: "userdefinedcode8", caption: "Code 8", dataType: "string" },
        {visible:false, dataField: "userdefinedcode9", caption: "Code 9", dataType: "string" },
        {visible:false, dataField: "userdefinedcode10", caption: "Code 10", dataType: "string" },
        {visible:false, dataField: "reportpagebreak", caption: "Report Page Break", dataType: "string" },
        {visible:false, dataField: "summarizedetails", caption: "Summarize Details", dataType: "string" },
        {visible:false, dataField: "bankrecsecurity", caption: "Bank REC Security", dataType: "string" },
    ]
};
// ACCURRENCY codes (server LookupType.ACCurrency). Legacy pickers are TDBArgosLookupEdits on
// frmACM0001.dsACCurrency with criteria fields CURRENCY / DESCRIPTION / RATETYPE (e.g. uOMD0012).
const ACCurrencyLayout = {
    valueExpr: 'id',
    displayExpr: 'name',
    sort: [{ selector: "name", desc: false }],
    searchEnabled: true,
    acceptCustomValue: false,
    gridKey: 'F1078A15-AC4E-4197-A839-245A9D528EE5',
    params: {
        module: "ac",
        lookupType: "ACCurrency",
        showLookupGrid: true
    },
    columns: [
        { dataField: "name", caption: "Currency", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "rateType", caption: "Rate Type", dataType: "string" },
        { dataField: "status", caption: "Status", dataType: "string", visible: false },
    ]
};
export {
    ACCurrencyLayout,
    ACDepartmentLayout,
    ACReceiptMethodSetup,
    AccountLookup
}